interface IPagerProps {
	currentPage: number;
	totalPages: number;
	onPage: (page: number) => void;
	// Whether search/sort operate on the current page only (server-paginated).
	showPageNote?: boolean;
}

/** Prev / page-status / Next pager — shared across the table and board views. */
const Pager = ({ currentPage, totalPages, onPage, showPageNote = true }: IPagerProps) => {
	if (totalPages <= 1) return null;
	return (
		<>
			<div className='qa-pager'>
				<button
					type='button'
					className='qa-pager__btn'
					disabled={currentPage <= 1}
					onClick={() => onPage(currentPage - 1)}
				>
					Prev
				</button>
				<span className='qa-pager__status'>
					Page {currentPage} of {totalPages}
				</span>
				<button
					type='button'
					className='qa-pager__btn'
					disabled={currentPage >= totalPages}
					onClick={() => onPage(currentPage + 1)}
				>
					Next
				</button>
			</div>
			{showPageNote && <p className='qa-pager__note'>Search &amp; sort apply to the current page.</p>}
		</>
	);
};

export default Pager;
